import React from "react";

export default function ExecutiveDashboard({ executiveSummary, revenueForecast }) {
  return (
    <div style={{ marginBottom: 32 }}>
      <h2>📊 AI Executive Dashboard</h2>

      <div style={executiveGridStyle}>
        <div style={executiveCardStyle}>
          <h3>Active Leads</h3>
          <h2>{executiveSummary.active}</h2>
        </div>

        <div style={executiveCardStyle}>
          <h3>Likely Wins</h3>
          <h2>{executiveSummary.likelyWins}</h2>
        </div>

        <div style={executiveCardStyle}>
          <h3>At-Risk Leads</h3>
          <h2>{executiveSummary.atRisk}</h2>
        </div>

        <div style={executiveCardStyle}>
          <h3>Proposals</h3>
          <h2>{executiveSummary.proposals}</h2>
        </div>

        <div style={executiveCardStyle}>
          <h3>Qualified</h3>
          <h2>{executiveSummary.qualified}</h2>
        </div>

        <div style={executiveCardStyle}>
          <h3>Hot Active Leads</h3>
          <h2>{executiveSummary.hot}</h2>
        </div>

        <div style={executiveCardStyle}>
          <h3>Total Pipeline Value</h3>
          <h2>€{revenueForecast.totalPipelineValue.toLocaleString()}</h2>
        </div>

        <div style={executiveCardStyle}>
          <h3>Expected Revenue</h3>
          <h2>€{revenueForecast.expectedRevenue.toLocaleString()}</h2>
        </div>
      </div>
    </div>
  );
}

const executiveGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: 16
};

const executiveCardStyle = {
  padding: "18px",
  borderRadius: "12px",
  background: "#eef2ff",
  border: "1px solid #c7d2fe"
};
